module.exports = __webpack_public_path__ + "img/4_002.9a2d9036.webp";